const padToTwoDigits = (num: number) => {
  if (num < 0 || num >= 100) {
    console.error("Number must be between 0 and 99");
    return "00";
  }
  return num < 10 ? "0" + num : num;
};

export const renderTime = (timeInMs: number) => {
  const timeInSeconds = Math.floor(timeInMs / 1000);
  return `${Math.floor(timeInSeconds / 60)}:${padToTwoDigits(timeInSeconds % 60)}`;
};
